/**
 * Interrupteur (toggle) visuel réutilisable — le petit switch pilule blanc
 * qui glisse. Partagé entre le filtre « non lus » (NotificationSidebar) et le
 * toggle « Afficher le classement aux élèves » (CoachRankings).
 *
 * Ne rend que le contrôle lui-même (input caché + piste + knob) ; le libellé
 * texte et la mise en page restent à la charge du parent, car ils diffèrent
 * d'un usage à l'autre.
 *
 * @param {string}   id       - id du checkbox (lié au htmlFor du parent si besoin)
 * @param {boolean}  checked  - état on/off
 * @param {Function} onChange - handler (reçoit l'événement input)
 * @param {number}   [opacity=1] - opacité de la piste (ex. 0.6 pendant un chargement)
 */
export default function ToggleSwitch({ id, checked, onChange, opacity = 1 }) {
  return (
    <div className="relative inline-block w-9 h-[18px] shrink-0">
      <input
        type="checkbox"
        id={id}
        checked={checked}
        onChange={onChange}
        className="sr-only"
      />
      <label
        htmlFor={id}
        className="block h-[18px] rounded-full cursor-pointer transition-colors duration-200"
        style={{
          backgroundColor: checked ? 'var(--kaiylo-primary-hex)' : '#404040',
          opacity,
        }}
      >
        <span
          className={`absolute top-[3px] left-[3px] w-3 h-3 bg-white rounded-full transition-transform duration-200 ${
            checked ? 'translate-x-[18px]' : 'translate-x-0'
          }`}
        />
      </label>
    </div>
  );
}
